import { environment } from '@environment';
import { initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';

import { InjectionToken, NgZone, Provider, inject } from '@angular/core';

export const FIREBASE_AUTH = new InjectionToken<Auth>('FIREBASE_AUTH');

export const provideFirebaseAuth = (): Provider => ({
  provide: FIREBASE_AUTH,
  useFactory: () =>
    inject(NgZone).runOutsideAngular(() =>
      getAuth(initializeApp(environment.firebase))
    ),
});
